import { fetchArtistById, Person } from 'common/apiService';
import Layout from 'common/Layout/Layout';
import ContentList from 'common/ContentList';
import Head from 'next/head';
import { __t } from 'common/i18n';
import { GetServerSideProps } from 'next';
import ArtistHeader from 'common/ArtistHeader';
import xIPCountry from 'common/apiService/xIPCountry';

export default function SingleArtistPage(props: Person) {
  const { name, videos, summary, short_id, slug } = props;

  return (
    <>
      <Head>
        <title>{name} | {__t('siteName')}</title>
        {summary?.trim() !== '' && <meta name="description" content={summary} />}
        <link rel="canonical" href={`/artists/${short_id}/${slug}`} />
      </Head>
      <ArtistHeader {...props} />
      <Layout disableTopGutter>
        {videos && <ContentList items={videos} />}
      </Layout>
    </>
  );
}

export const getServerSideProps: GetServerSideProps<Person, { id: string; }> = async ({ params, req, res }) => {
  xIPCountry({ req, res });
  const { id: shortId } = params ?? {};
  if (!shortId) return { notFound: true };

  try {
    const { data } = await fetchArtistById(shortId);

    return {
      props: data,
    };
  } catch (error) {
    if (error.response.status === 404) return { notFound: true };
    throw new Error(error);
  }
};
